'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('TipoOcorrenciaCtrl', function($scope, $rootScope, $route, $q, filterFilter,
  Flash, TiposOcorrenciasService, LoadingService, MessagesService, IndicadoresOcorrenciasService, AtividadesService) {
  $scope.tiposDeOcorrencia = TIPOS_OCORRENCIA;
  $scope.tiposDeIndicadores = TIPOS_INDICADORES;
  $scope.classificacoes = CLASSIFICACOES_INVASORA;
  $scope.sortableIndicadorOptions = {
    handle: '.sortable-indicadores',
    stop: function() {
      const indicadoresSelecionados = $scope.newTipoOcorrencia.selectIndicadores
        .filter((indicador) => indicador.selected);

      indicadoresSelecionados.forEach((indicador, index) => {
        $scope.newTipoOcorrencia.selectIndicadores.find((ind) => indicador === ind).ordem = index;
      });
    }
  };

  const DEFAULT_NUMERO_FAIXAS = 3;
  const DEFAULT_EQUILIBRIO = 5;
  const DEFAULT_ALTO_EQUILIBRIO = 10;
  const DEFAULT_CONTROLE = 15;
  const DEFAULT_EXTREMO = 20;
  const DEFAULT_FAIXAS = [DEFAULT_EQUILIBRIO, DEFAULT_ALTO_EQUILIBRIO];

  const error = function() {
    MessagesService.alert('Ocorreu um erro, tente novamente mais tarde.');
  };

  const transformAtividades = function() {
    if ($scope.newTipoOcorrencia.id) {
      const atividadeIds = ($scope.newTipoOcorrencia.atividadesAlvo || '').split(',');
      $scope.newTipoOcorrencia.arrayAtividades = (atividadeIds || []).map(function(atividadeId) {
        return filterFilter($scope.atividades, { id: parseInt(atividadeId) }, true)[0];
      }).filter(Boolean);
    }
  };

  //eslint-disable-next-line
  const transformFaixasIndicadores = function(indicador) {
    let faixas = [];
    switch (indicador.numero_faixas) {
    case 4:
      faixas = [
        +indicador.equilibrio || DEFAULT_EQUILIBRIO,
        +indicador.alto_equilibrio || DEFAULT_ALTO_EQUILIBRIO,
        +indicador.controle || DEFAULT_CONTROLE
      ];
      break;
    case 5:
      faixas = [
        +indicador.equilibrio || DEFAULT_EQUILIBRIO,
        +indicador.alto_equilibrio || DEFAULT_ALTO_EQUILIBRIO,
        +indicador.controle || DEFAULT_CONTROLE,
        +indicador.emergencia || DEFAULT_EXTREMO
      ];
      break;
    default:
      faixas = [
        +indicador.equilibrio || DEFAULT_EQUILIBRIO,
        +indicador.controle || DEFAULT_ALTO_EQUILIBRIO
      ];
    }
    return faixas;
  };

  const transformIndicadores = function() {
    $scope.newTipoOcorrencia.selectIndicadores.forEach(function(indicador) {
      const indicadores = $scope.newTipoOcorrencia.indicadores || [];
      const indicadorFilter = filterFilter(indicadores, { cd_indicador: indicador.id }, true)[0] || null;
      if (indicadorFilter) {
        indicador.selected = true;
        indicador.equilibrio = indicadorFilter.equilibrio;
        indicador.alto_equilibrio = indicadorFilter.alto_equilibrio;
        indicador.controle = indicadorFilter.controle;
        indicador.emergencia = indicadorFilter.emergencia;
        indicador.extremo = indicadorFilter.extremo;
        indicador.numero_faixas = indicadorFilter.numero_faixas;
        indicador.ordem = indicadorFilter.ordem;
        if (indicador.tipo.temFaixas) {
          indicador.faixas = transformFaixasIndicadores(indicador);
        }
      }
    });
    $scope.newTipoOcorrencia.selectIndicadores = _.orderBy($scope.newTipoOcorrencia.selectIndicadores, 'ordem', 'asc');
  };

  $scope.addIndicador = function($select) {
    const maxOrder = $scope.newTipoOcorrencia.selectIndicadores
      .filter((indicador) => indicador.selected)
      .length;
    $scope.newTipoOcorrencia.selectIndicadores.forEach(function(indicador) {
      if (indicador.id === $select.id) {
        indicador.selected = true;
        indicador.ordem = maxOrder;
        if (indicador.tipo.temFaixas) {
          indicador.faixas = DEFAULT_FAIXAS;
        }
        indicador.numero_faixas = DEFAULT_NUMERO_FAIXAS;
      }
    });
    // eslint-disable-next-line
    $scope.indicador.selected = undefined;
  };

  $scope.removeIndicador = function(indicador) {
    indicador.selected = false;
  };

  const initializeVariables = function() {
    $scope.newTipoOcorrencia = {};
    $scope.atividades = [];
    $scope.indicador = {
      //eslint-disable-next-line
      selected: undefined
    };
  };

  //eslint-disable-next-line
  const initialize = function(params) {
    $scope.showFaixas = false;
    if (!$rootScope.permissions.tipos_ocorrencia.canManage) {
      closeTipoOcorrencia();
      Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
      return;
    }

    initializeVariables();

    const promises = [
      IndicadoresOcorrenciasService.list(),
      AtividadesService.list()
    ];

    if ((params || {}).id) {
      promises.push(TiposOcorrenciasService.getTipoOcorrencia(params.id));
    }

    LoadingService.showLoading();
    $q.all(promises).then(function(results) {
      $scope.newTipoOcorrencia = results[2] || {
        ativo: true
      };
      $scope.newTipoOcorrencia.selectIndicadores = (results[0].data || []).map(function(indicador) {
        indicador.tipo = filterFilter($scope.tiposDeIndicadores, { id: indicador.tipo }, true)[0] || {};
        indicador.faixas = indicador.tipo.temFaixas ? [DEFAULT_EQUILIBRIO, DEFAULT_CONTROLE] : [];
        indicador.selected = false;
        return indicador;
      });
      $scope.atividades = results[1].data || [];
      transformAtividades();
      transformIndicadores();
      $scope.showFaixas = true;
    //eslint-disable-next-line
    }, error).finally(LoadingService.hideLoading);
  };

  $scope.save = function(form) {
    if (form.$invalid) {
      return;
    }

    LoadingService.showLoading();
    const method = $scope.newTipoOcorrencia.id ? TiposOcorrenciasService.update : TiposOcorrenciasService.save;
    method($scope.newTipoOcorrencia).then(function() {
      $route.reload();
      Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
      closeTipoOcorrencia();
    }, function() {
      Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
    })
      .finally(function() {
        LoadingService.hideLoading();
      });
  };

  $scope.cancel = function() {
    closeTipoOcorrencia();
  };

  $scope.isValidRange = function(indicador, tipoOcorrencia) {
    const faixas = parseInt(indicador.numero_faixas);

    if (tipoOcorrencia === 'inimigo_natural' && indicador.selected) {
      return faixas !== 3;
    }
    return faixas < 3 || faixas > 5;
  };

  function closeTipoOcorrencia() {
    $scope.newTipoOcorrencia = null;
    $rootScope.$broadcast('deactiveTipoOcorrencia');
  }

  $scope.$on('activeTipoOcorrencia', function(event, params) {
    initialize(params);
  });

  $scope.$watch('[newTipoOcorrencia.selectIndicadores, newTipoOcorrencia.tipo]', function() {
    const indicadores = ($scope.newTipoOcorrencia || {}).selectIndicadores;
    $scope.indicadoresInvalidos = _.filter(indicadores, function(indicador) {
      return $scope.isValidRange(indicador, ($scope.newTipoOcorrencia.tipo || {}).id);
    });
  }, true);
});
